import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'memberships',
  owner: 'cella',
  scope: ['frontend', 'backend'],
  description: 'UI for managing user memberships in channels.',
});
